export default __webpack_public_path__ + "static/media/ppt.109358d2.svg";